/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum PedestrianPathType {
    ILLUMINATED = 'ILLUMINATED',
    PAVED_ROAD = 'PAVED_ROAD',
    OTHER = 'OTHER',
}
